import { Text, VStack } from "@chakra-ui/react";

export const NotFoundPage = () => (
  <VStack spacing={8}>
    <Text>Not found!</Text>
  </VStack>
);
